import React from "react";
import { motion } from "framer-motion";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/ge0hdtvo_Custom_Jersey_Video%20%281%29.mp4";

const tiles = [
  {
    // Main feature — the custom jersey reel
    type: "video",
    src: VIDEO_URL,
    poster:
      "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/h4b1vodl_WhatsApp%20Image%202026-05-05%20at%2016.55.35.jpeg",
    alt: "Custom sublimation jerseys — in motion",
    label: "Reel",
    tag: "Jerseys",
    span: "col-span-12 md:col-span-8 md:row-span-2",
    bg: "#FF0055",
    fg: "#FFFFFF",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/3k50gg6v_WhatsApp%20Image%202026-05-05%20at%2016.55.34.jpeg",
    alt: "UNIX team champions celebrating with trophy in red-and-black sublimation jerseys",
    label: "Champions",
    tag: "UNIX",
    span: "col-span-12 md:col-span-4 md:row-span-1",
    bg: "#FFE600",
    fg: "#0A0A0A",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/ck3frgau_WhatsApp%20Image%202026-05-05%20at%2016.55.36.jpeg",
    alt: "SUKHIDA Prime team with medals in black-and-green sublimation jerseys",
    label: "Medals",
    tag: "SUKHIDA",
    span: "col-span-12 md:col-span-4 md:row-span-1",
    bg: "#00F0FF",
    fg: "#0A0A0A",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/h4b1vodl_WhatsApp%20Image%202026-05-05%20at%2016.55.35.jpeg",
    alt: "RK Star 52 cricket team in custom light-blue sublimation kit with Frootree sponsor",
    label: "Kit",
    tag: "RK Star 52",
    span: "col-span-12 md:col-span-4 md:row-span-1",
    bg: "#0A0A0A",
    fg: "#FFE600",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/v7eynedl_WhatsApp%20Image%202026-05-05%20at%2016.55.34%20%281%29.jpeg",
    alt: "Sun Moon Electricals sponsored team in black-and-purple sublimation jerseys",
    label: "Sponsor",
    tag: "Sun Moon",
    span: "col-span-12 md:col-span-4 md:row-span-1",
    bg: "#FF0055",
    fg: "#FFFFFF",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/nga7vw36_COTTON%20POLO%20BLACK.jpeg",
    alt: "Black cotton polo with embroidered OPPO logo for corporate uniform",
    label: "Embroidery",
    tag: "OPPO",
    span: "col-span-12 md:col-span-4 md:row-span-1",
    bg: "#FFE600",
    fg: "#0A0A0A",
  },
  {
    type: "image",
    url: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-forge-60/artifacts/gks9amrk_WhatsApp%20Image%202026-09-16%20at%2015.12.48.jpeg",
    alt: "Purple cap with embroidered Kia Tennis Premier League logo — custom promotional merchandise",
    label: "Cap Embroidery",
    tag: "Kia · Tennis Premier League",
    span: "col-span-12 md:col-span-4 md:row-span-1",
    bg: "#0A0A0A",
    fg: "#FFE600",
  },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      className="border-b-4 border-black py-20 lg:py-28 bg-white"
      data-testid="portfolio-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 lg:mb-16">
          <div className="max-w-3xl">
            <div className="font-heading uppercase text-xs tracking-[0.3em] text-[#555] mb-4">
              /// Selected work
            </div>
            <h2 className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              Prints that <span className="text-[#FF0055]">punch.</span>
              <br />
              Fits that{" "}
              <span className="underline decoration-[#FFE600] decoration-[10px] underline-offset-4">
                fit.
              </span>
            </h2>
          </div>
          <p className="max-w-sm text-base text-[#0A0A0A]/70">
            A small slice of recent orders — from gameday jerseys to sponsor kits.
            Ask us for the full book.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-5 md:gap-6 auto-rows-[200px] md:auto-rows-[260px]">
          {tiles.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`nb-tile nb-border-4 nb-shadow-sm ${t.span}`}
              data-testid={`portfolio-tile-${i}`}
            >
              {t.type === "video" ? (
                <video
                  src={t.src}
                  poster={t.poster}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-cover"
                  aria-label={t.alt}
                />
              ) : (
                <img
                  src={t.url}
                  alt={t.alt}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              )}
              <div
                className="absolute bottom-3 left-3 nb-border-2 px-3 py-1.5 font-heading uppercase text-xs tracking-wider"
                style={{ background: t.bg, color: t.fg }}
              >
                {t.label} · {t.tag}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
